import { render } from "./TheHeader.vue?vue&type=template&id=64bbaf7c&scoped=true&ts=true"
import script from "./TheHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./TheHeader.vue?vue&type=script&setup=true&lang=ts"

import "./TheHeader.vue?vue&type=style&index=0&id=64bbaf7c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64bbaf7c"],['__file',"src/lib/components/header/TheHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64bbaf7c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64bbaf7c', __exports__)) {
    api.reload('64bbaf7c', __exports__)
  }
  
  module.hot.accept("./TheHeader.vue?vue&type=template&id=64bbaf7c&scoped=true&ts=true", () => {
    api.rerender('64bbaf7c', render)
  })

}


export default __exports__